function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import MD5 from 'md5.js';
import { calculateId } from 'internals/helpers';
export var convertHouseIdToInt = function convertHouseIdToInt(houseId) {
  return parseInt(calculateId(houseId), 10);
};
export var hashWithMD5 = function hashWithMD5(string) {
  return new MD5().update(string).digest('hex');
};
export function mapStringToBoolean(value) {
  var mapper = {
    yes: true,
    no: false,
    any: null
  };
  var ret = mapper[value];
  return ret !== undefined ? ret : null;
}
export function formatFilters(filters) {
  return {
    filter_value_valor_type: filters.priceType,
    filter_value_valor_min: filters[filters.priceType].min,
    filter_value_valor_max: filters[filters.priceType].max,
    filter_list_rooms: filters.bedrooms,
    filter_type_of_property: filters.houseTypes,
    filter_value_area_min: filters.area.min,
    filter_value_area_max: filters.area.max,
    filter_list_parking: filters.parkingSpaces,
    filter_value_furnished: mapStringToBoolean(filters.furnished),
    filter_value_metro: mapStringToBoolean(filters.nearSubway),
    filter_value_pets: mapStringToBoolean(filters.acceptsPets),
    filter_list_apartment: filters.installations,
    filter_list_condo: filters.amenities
  };
}
export function formatMapBounds(bounds) {
  return {
    map_borders_lat_sw: bounds.south,
    map_borders_lng_sw: bounds.west,
    map_borders_lat_ne: bounds.north,
    map_borders_lng_ne: bounds.east
  };
}
export var isEnabled = function isEnabled() {
  try {
    localStorage.setItem('key', '1');
    localStorage.removeItem('key');
    return true;
  } catch (error) {
    return false;
  }
};
export var getKeyFromLocalStorage = function getKeyFromLocalStorage(key) {
  return isEnabled() ? localStorage.getItem(key) : null;
};
export var setKeyToLocalStorage = function setKeyToLocalStorage(key, value) {
  if (isEnabled()) {
    localStorage.setItem(key, value);
  }
};
export var serializeArrayItems = function serializeArrayItems(value) {
  return value.map(function (item) {
    return JSON.stringify(item);
  });
};
export var serializeObjects = function serializeObjects(value) {
  if (_typeof(value) === 'object') {
    return JSON.stringify(value);
  }
  return value;
};
export var removeNullsPropertiesFromObjects = function removeNullsPropertiesFromObjects(value) {
  var filtered = value;
  Object.keys(value).map(function (key) {
    if (value[key] === null) {
      delete filtered[key];
    }
    return key;
  });
  return filtered;
};
export var serializeObjectsProperties = function serializeObjectsProperties(value) {
  var filtered = value;
  Object.keys(value).map(function (key) {
    filtered[key] = serializeObjects(value[key]);
    return value[key];
  });
  return filtered;
};